export default __webpack_public_path__ + "static/media/logo_alsum_saja.947e63d4.png";